import { Sparkles } from '@/components/feedback/sparkles';
import clsx from 'clsx';
import { IconButton } from '@/layouts/authenticated/components/top-navigation/components/icon-button';
import * as styles from './support-chat-button.css';
import { useSupportChat, useSupportChatSparkles } from '../hooks';

function SupportChat() {
  const { openChat, isLoading, unreadCount, isVisible, zendeskChatEnabled } = useSupportChat();
  const { shouldShowSparkle, disableSparkle } = useSupportChatSparkles();

  if (isVisible !== true || zendeskChatEnabled !== true) {
    return null;
  }

  return (
    <Sparkles onHide={disableSparkle} show={shouldShowSparkle}>
      <IconButton
        icon="chat"
        label="Support chat"
        isLoading={isLoading}
        onClick={() => {
          openChat();
          disableSparkle();
        }}
        data-test-support-chat
      >
        <span className={clsx(styles.chatCount, unreadCount > 0 && styles.chatCountUnread)}>{unreadCount}</span>
      </IconButton>
    </Sparkles>
  );
}

export { SupportChat };
